import React, { FC } from 'react';
import Link, { LinkProps } from '../Link';

export interface TelLinkProps extends LinkProps {
  phone: string;
}

const TelLink: FC<TelLinkProps> = ({ phone, children, ...props }) => (
  <Link href={`tel:${phone}`} {...props}>{children}</Link>
);

export default TelLink;
